import * as accountOpeningAPI from 'login-apis/accountOpeningAPI';
import * as loanUtils from './loanUtils';
import * as userUtils from './userUtils';
import { getWindow } from './globalWrappers';

export function shouldUpdateAccountOpeningApp(): boolean {
  return !!userUtils.getCurrentUser() && !!loanUtils.getSelectedProductId();
}

export async function updateAccountOpeningApp(
  accounts: accountOpeningAPI.Account[],
  productReferenceId?: string,
): Promise<void> {
  const selectedProductId = loanUtils.getSelectedProductId();
  await accountOpeningAPI.updateAccountOpeningApp(selectedProductId!, { accounts, productReferenceId });
  // Reload the page to redirect the user to the borrower app
  getWindow().location.reload();
}
